import { render, staticRenderFns } from "./fenpai.vue?vue&type=template&id=85b7a512&scoped=true&"
import script from "./fenpai.vue?vue&type=script&lang=js&"
export * from "./fenpai.vue?vue&type=script&lang=js&"
import style0 from "./fenpai.vue?vue&type=style&index=0&id=85b7a512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b7a512",
  null
  
)

export default component.exports